import { render } from "./MedicalRecords.vue?vue&type=template&id=784d8f90&ts=true"
import script from "./MedicalRecords.vue?vue&type=script&lang=ts"
export * from "./MedicalRecords.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/armieisla/workspace/charmedteq/icare/icare-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__